import { render } from "./Custom.vue?vue&type=template&id=3c4ced6e&scoped=true&ts=true"
import script from "./Custom.vue?vue&type=script&lang=ts"
export * from "./Custom.vue?vue&type=script&lang=ts"

import "./Custom.vue?vue&type=style&index=0&id=3c4ced6e&lang=scss&scoped=true"
import "./Custom.vue?vue&type=style&index=1&id=3c4ced6e&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4ced6e"]])

export default __exports__